import type {MenuItemData, MenuItemTag, PosMenuItem} from '@PosterWhiteboard/items/menu-item/menu-item.types';

export const USER_MENU_LIST_ID = 'User-menu-items';
export const POS_MENU_LIST_ID = 'Pos-menu-items';
export const SELECTED_MENU_LIST_ID = 'Selected-menu-items';
export const SEARCH_MENU_LIST_ID = 'Search-menu-items';
export const USER_MENU_MODAL_TABS_ID = 'user-menu-modal-tabs';
export const POLLING_EVENT_ID = 'pos-loging-in';
export const BATCH_LIMIT = 50;
export const EMPTY_LIST_ITEMS: string[] = [];
export enum CharacterLimit {
  NAME = 100,
  DESCRIPTION = 400,
  PRICE = 50,
}

export enum ImageSrc {
  SQUARE = 'images/postermaker/pos-square-logo.png',
}

export enum PosLoadingStates {
  DEFAULT = 0,
  LOGGING_IN = 1,
  LOADING_ITEMS = 2,
  LOADED_ITEMS = 3,
}

export enum TABS {
  STYLE = 'style',
  ALL_ITEMS = 'all-items',
  SELECTED_ITEMS = 'selected-items',
}

export enum ItemSource {
  ALL = 'all',
  POS = 'pos',
  PMW = 'pmw',
}

export enum MenuItemKeys {
  NAME = 'name',
  PRICE = 'price',
  ICONS_LIST = 'iconsList',
  ADDONS_LIST = 'addOnsList',
  DESCRIPTION = 'description',
  VARIATIONS_LIST = 'variationsList',
}

export enum BasicInfo {
  NAME = 'name',
  PRICE = 'price',
  DESCRIPTION = 'description',
}

export enum ItemVariationListType {
  SIZE = 'variationsList',
  ADDON = 'addOnsList',
}

export enum ItemVariationData {
  NAME = 'name',
  PRICE = 'price',
}

export interface MenuItemIcon {
  id: string;
  name: string;
}

export interface PosAccountInfo {
  isAvailable: boolean;
  data: PosMenuItem[];
}

export interface UnlinkAccountInfo {
  unlinked: boolean;
}

export interface PosCatalogBackendData {
  items: PosMenuItem[];
  categories: MenuItemTag[];
  cursor?: string;
}

export interface MenusBackendData {
  items: MenuItemData[];
  categories: MenuItemTag[];
}
